/** @jsx jsx */
import { css, jsx } from '@emotion/react';

import * as React from 'react';
import { useState } from 'react';

import { Button, PasswordField } from '@coursera/cds-core';

import SettingsActionCreators from 'bundles/account-settings/actions/SettingsActionCreators';
import SettingsModal from 'bundles/account-settings/components/common/SettingsModal';
import FormError from 'bundles/account-settings/components/sections/two-factor/FormError';

import _t from 'i18n!nls/account-settings';

type Props = {
  updating: boolean;
  invalidFields: string[];
  submitAction: (x0: string) => void;
  title: string;
};

const styles = {
  actions: css`
    display: flex;
    flex-direction: row;
    gap: var(--cds-spacing-150);
    align-items: end;
  `,
  // Overrides from parent cascading styles
  input: css`
    width: 100%;

    label + div {
      margin-top: 0 !important;
    }

    input,
    button {
      margin-bottom: 0 !important;
      margin-top: 0 !important;
      border: none !important;
    }
  `,
  // Overrides from parent cascading styles
  button: css`
    height: 41px !important;
    border-radius: var(--cds-border-radius-50) !important;
  `,
};

const PasswordConfirmationModal = ({ updating, invalidFields, submitAction, title }: Props) => {
  const [password, setPassword] = useState('');

  const handleSubmit = () => {
    submitAction(password);
  };

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setPassword(event.target.value.trim());
  };

  const handleClose = () => {
    SettingsActionCreators.cancelTwoFactorAuthenticationAction();
  };

  return (
    <div className="rc-EnableTwoFactorAuthentication">
      <SettingsModal title={title} onClose={handleClose}>
        <FormError fields={invalidFields} />
        <div>
          <PasswordField
            css={styles.input}
            label={_t('Please confirm your password')}
            placeholder={_t('Password')}
            autoComplete="current-password"
            onChange={handleChange}
          />
        </div>
        <Button variant="primary" onClick={handleSubmit} disabled={updating}>
          {_t('Continue')}
        </Button>
      </SettingsModal>
    </div>
  );
};

export default PasswordConfirmationModal;
